import { render, staticRenderFns } from "./huovArrDep.vue?vue&type=template&id=30828ccd"
import script from "./huovArrDep.vue?vue&type=script&lang=js"
export * from "./huovArrDep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports